import CookiesRepository from '~/core/ts/repository/CookiesRepository'

export function useExternalAffiliate() {
  const route = useRoute()

  const runtime = useRuntimeConfig()
  const externalDepsActive = ref(false)

  function checkNoDepsMode() {
    if (runtime.public.isLocal) {
      return
    }

    const noDepsCookie = CookiesRepository.getCookiesAsText('spl-no-external-deps-mode')
    if (noDepsCookie) {
      return
    }

    const noExternalDepsMode = route.query['spl-no-external-deps-mode'] as string || null
    if (noExternalDepsMode) {
      CookiesRepository.addCookieExpiredInHours('spl-no-external-deps-mode', 1, 1)
      return
    }

    externalDepsActive.value = true
  }

  function getSourceChannel() {
    const source = route.query['source'] as string || null
    if (source) { return source }

    const gclid = route.query['gclid'] as string || null
    if (gclid) { return 'ga' }

    const fbclid = route.query['fbclid'] as string || null
    if (fbclid) { return 'fb' }

    const utmSource = route.query['utm_source'] as string || null
    if (utmSource === 'google') { return 'ga' }
    if (utmSource === 'facebook') { return 'bf' }

    return ''
  }

  onMounted(() => {
    checkNoDepsMode()

    const awc = route.query['awc'] as string || null
    if (awc) {
      CookiesRepository.addCookie('awc', awc)
    }

    const source = getSourceChannel()
    if (source) {
      CookiesRepository.addCookie('source', source)
    }
  })

  return {
    externalDepsActive,
  }
}
